import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = () => {
  const dataPoints = useSelector((state) => state.classCount.dataPoints);

  return (
    <div data-testid="scorecards" className="scorecards">
      {dataPoints.map(({ value, label, url, tooltip }, index) => (
        <div key={index} className="scorecard">
          <DataDisplay
            value={value}
            label={label}
            url={url}
            toolTipContent={tooltip}
            toolTipId={`classCount_datapoint_tooltip_${index}`}
            disableAnimation
            sectionProps={{ toolTip: tooltip, toolTipId: `classCount_datapoint_tooltip_${index}` }}
          />
        </div>
      ))}
    </div>
  );
};
